import React, { useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import clean from "../assets/icons/—Pngtree—cleaning tools_5412307.png";
import s1 from "../assets/images/s1.webp"
import s2 from "../assets/images/ss2.webp"
import s3 from "../assets/images/ss3.webp"


gsap.registerPlugin(ScrollTrigger);

const About1 = () => {
  const sectionRef = useRef(null);
  const imagesRef = useRef([]);

  useGSAP(
    () => {
      gsap.fromTo(
        imagesRef.current,
        {
          y: 120,
          opacity: 0,
          scale: 0.9,
        },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          stagger: 0.25,
          ease: "power3.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 80%",
            end: "bottom 40%",
            scrub: 1.2,
          },
        }
      );
    },
    { scope: sectionRef }
  );

  return (
    <section
      ref={sectionRef}
      className="relative overflow-hidden pt-12 pb-24 lg:pt-[120px] lg:pb-[140px] bg-[#f0f8ff]"
    >
      {/* floating decoration */}
      <img
        src={clean}
        className="absolute top-0 left-0 w-60 opacity-90 "
        alt=""
      />

      <div className="container mx-auto">
        <div className="flex flex-wrap items-center justify-between">

          {/* LEFT IMAGE SECTION */}
          <div className="w-full px-4 lg:w-6/12">
            <div className="flex items-center -mx-3 sm:-mx-4">

              <div className="w-full px-3 sm:px-4 xl:w-1/2 space-y-6">
                <div
                  ref={(el) => (imagesRef.current[0] = el)}
                  className="rounded-2xl overflow-hidden shadow-xl hover:scale-105 transition-transform"
                >
                  <img
                    src={s1}
                    alt=""
                    className="w-full"
                  />
                </div>

                <div
                  ref={(el) => (imagesRef.current[1] = el)}
                  className="rounded-2xl overflow-hidden shadow-xl hover:scale-105 transition-transform"
                >
                  <img
                  src={s2}
                    alt=""
                    className="w-full"
                  />
                </div>
              </div>
              <div className="w-full px-3 sm:px-4 xl:w-1/2">
                <div
                  ref={(el) => (imagesRef.current[2] = el)}
                  className="relative z-10 my-4 rounded-2xl overflow-hidden shadow-2xl hover:scale-105 transition-transform"
                >
                  <img
                    src={s3}                  
                     alt=""
                    className="w-full"
                  />
                </div>
              </div>

            </div>
          </div>

          {/* RIGHT TEXT SECTION */}
          <div className="w-full px-4 lg:w-1/2 xl:w-5/12">
            <div className="mt-10 lg:mt-0">
              <span className="block mb-4 text-lg tracking-[0.3em] font-semibold text-[#079dcc]">
                ABOUT US
              </span>

              <h2 className="mb-5 text-3xl font-bold text-[#e58505] sm:text-[40px]/[48px]">
                Make customers happy with our service.
              </h2>

              <p className="mb-5 text-base text-body-color">
                We make homes and offices shine while keeping our customers happy.
                Our trained team ensures thorough, safe, and reliable cleaning
                every time.
              </p>

              <p className="mb-8 text-base text-body-color">
                At Safaiwala, we believe in building trust through quality service
                and attention to detail. From deep cleaning to everyday
                maintenance, we make your space spotless and welcoming.
              </p>

              <p className="mb-8 text-base text-body-color">
                Start your cleaning journey with us today!
              </p>

              <a
                href="#"
                className="inline-block bg-[#079dcc] text-white px-6 py-2 rounded-full font-semibold hover:bg-[#067fa3] transition-colors"
              >
                Read More
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default About1;
